<style lang="scss">
.menu-title {
	cursor: pointer;
	user-select: none;
	padding: 2px 12px 2px 6px;
	float: unset !important;
	&:hover {
		background-color: #d5e8fc;
	}
}

.menu-node-btn {
	float: right;
	display: block;
	button {
		margin-right: 8px;
	}
}
.ivu-tree ul{
    font-size:12px
}
.menu-title-active {
	background-color: #ffbb00;
}
.product-tree .product-tree-component .menu-title-active {
    background-color: #ffbb00;
}
.menu-title-active2 {
	background-color: #d5e8fc;
}
</style>

<template>
	<div class="product-tree">
        <vInput
			class="menu-search margin-right-10"
			v-model="search"
			@on-enter="handleInput"
			suffix="search"
			@on-icon-click="handleInput"
			placeholder="输入部门名称，模糊搜索"
		></vInput>
        <div >
            <Tree
			:data="getNodes"
			:render="renderNode"
			ref="tree"
            multiple
		></Tree>
        </div>
	</div>
</template>

<script>
import mixin from '../mixins'

export default {
    props:["cuttentDepartment","dataList"],
    mixins: [ mixin ],
	data() {
		return {
            search: "",
			operateId: '',
			linkIndex: "",
			getBillcategory:[],
            searchAllDept: [],
            searchDept: [],
            deptList: [],
		};
	},
    watch: {
        "cuttentDepartment": {
            handler (val) {
                this.operateId=val.id
            }
        },
        "dataList": {
            immediate: true,
            handler (val) {
                this.deptList = val
            },
        }
    },
	created(){
        this.getNode(1)
	},
	computed: {
		getNodes() {
			const data = JSON.parse(JSON.stringify(this.deptList))
			const Nodes = [];
			data.forEach(item => {
                if( this.searchAllDept.indexOf(item.id) > -1){
                    item.expand=true
                }else{
                    item.expand=false
                }
				const parentId = item.parentId;
				if (!parentId) return Nodes.push(item);
				const parent = data.find(function (item) {
					return parentId === item.id;
				});
				if (!parent) return;
				const children = parent.children;
				if (children) {
					children.push(item);
				} else {
					parent.children = [item];
				}
			});
			Nodes.forEach((item) => {
				item.expand = true;
			})
			return Nodes;
		},
	},
	methods: {
        handleInput (val) {
            let indistinctTarget,
				// target = this.deptList.find(function (item) {
				// 	if (!indistinctTarget && val && `${item.name}`.indexOf(val) > -1 && `${item.name.toLowerCase().indexOf(val.toLowerCase()) > -1}`) indistinctTarget = item;
				// 	return val && (val == item.code || val == item.name || val == item.nameEn || item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
				// }) || indistinctTarget,
                result = this.deptList.filter(item=>{
                    if (!indistinctTarget && val && `${item.name}`.indexOf(val) > -1 && `${item.name.toLowerCase().indexOf(val.toLowerCase()) > -1}`) indistinctTarget = item;
					return val && (val == item.code || val == item.name || val == item.nameEn || item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
                })
            if (result.length > 0) {
				// this.$refs.tree.initStatus(['id', this.operateId = target.id]);
                this.searchAllDept = []
                this.searchDept = []
                result.map(item=>{
                    this.findAllNodes(item)
                    this.searchDept.push(item.id)
                });
                this.$emit('on-data', result[0].id);
                setTimeout(() => {
					const ele = document.querySelector(`.vview-treenode-li[data-id="${this.operateId}"]`);
					ele?ele.scrollIntoView({ block: "center" }):'';
				}, 600)
			}
        },
        findAllNodes(node){
            this.searchAllDept.push(node.id)
            this.searchAllDept=Array.from(new Set(this.searchAllDept))
            const parent = this.deptList.filter(item => item.id === node.parentId)[0]
            if(parent){
                this.findAllNodes(parent)
            }
        },
		renderNode(h, { root, node, data })
		{
			let active = this.operateId === data.id;
            let active2 = this.searchDept.indexOf(data.id) > -1
			return h('div', {
				class: [
					'menu-title',
					{
						'menu-title-active': active2,
						'menu-title-active2': active
					}
				],
                on: {
                    click: (event) => {
						event.stopPropagation();
						this.getNode(data.id);
					},
				},
			}, [data.name])
		},
		getNode(id) {
			this.operateId = id;
			this.$emit('on-data', id);
		},
	},
};
</script>
